import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { I18n, NgtButtonComponent } from '@corporate/ng-tebis-base-components';
import { WindowStore } from '../window-tabs/window.store';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'tps-copy-context-link',
  imports: [
    NgtButtonComponent,
  ],
  templateUrl: './copy-context-link.component.html',
  styleUrl: './copy-context-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CopyContextLinkComponent {

  i18n = inject(I18n);
  windowStore = inject(WindowStore);
  snackBar = inject(MatSnackBar);

  context = input.required<string|string[]>();

  copy() {
    window.navigator.clipboard.write([new ClipboardItem({'text/plain': this.windowStore.getRestoreUrl(this.context())}, {presentationStyle: 'inline'})]).then(() => {
      this.snackBar.open(this.i18n.translate('copiedToClipboard')(), 'OK', { duration: 2000 });
    });
  }
}
